import { Directive } from '@angular/core';

@Directive({
  standalone: true,
  selector: '[isaModalHeader]',
})
export class ModalHeaderDirective {}
